<template>
  <div>
    <div class="banner-invest">
      <div class="container ">
        <div class="banner-inner">
          <h2 class="title-invest">Откройте мир <span>инвестиций</span> по-новому
          </h2>
          <div class="colums">
            <p class="text-invest">
              Получайте ценные сведения от экспертов рынка и принимайте взвешенные решения,
              как и куда вложить свои средства.
            </p>
            <template v-if="invType">
              <template v-if="invType === 1">
                <ButtonAction
                    class="main-action-btn"
                    type="submit"
                    message="Присоединиться"
                    @buttonAction="hasSubscription"
                />
              </template>
              <template v-else>
                <ButtonAction
                    class="main-action-btn"
                    type="submit"
                    message="Присоединиться"
                    @buttonAction="hasProfileNoSubscription"
                />
              </template>
            </template>
            <template v-else>
              <ButtonAction
                  class="main-action-btn"
                  type="submit"
                  message="Присоединиться"
                  @buttonAction="hasProfileNoSubscription"
              />
            </template>
          </div>
          <div class="img-invest"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonAction from '@/components/newRedesign/UI/ButtonAction';

export default {
  components: {
    ButtonAction
  },
  computed: {
    invType() {
      return this.$store.state.user?.payment?.inv_type;
    }
  },
  methods: {
    hasSubscription() {
      this.$router.push("/investments")
    },
    hasProfileNoSubscription() {
      this.$router.push("/landing-invest")
    },
    NoSubscription() {
      this.$router.push("/login-invest")
    },
  }
};
</script>

<style scoped lang="scss">
.banner-invest {
  padding-top: 28px;
  padding-bottom: 40px;


  .banner-inner {
    background-image: url('../../../assets/img/bg_banner_invest.png');
    background-position: center;
    background-size: cover;
    position: relative;
    padding: 60px 30px;
    background-color: #F2F2F2;
    box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.2);
    border-radius: 12px;

    .title-invest {
      margin-bottom: 58px;
      font-family: 'Gilroy';
      font-style: normal;
      font-weight: 600;
      font-size: 48px;
      line-height: 27px;
      color: #333333;

      span {
        font-style: italic;
        color: #22B491;
      }
    }

    .colums {
      display: flex;
      align-items: center;

      .text-invest {
        width: 456px;
        margin-right: 30px;
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 30px;
        color: #333333;
      }

      .btn-invest {
        display: flex;
        text-align: center;
      }

      .btn-invest:active,
      .btn-invest:hover,
      .btn-invest:focus {
        outline: 0;
        outline-color: transparent;
        outline-width: 0;
        outline-style: none;
        box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
      }

      .btn-invest::-moz-focus-inner {
        border: 0;
      }
    }

    .img-invest {
      background-image: url("../../../assets/img/banner_invest.webp");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      width: 307px;
      height: 342px;
      position: absolute;
      top: 0;
      right: 20px;
    }
  }
}

@media screen and (max-width: 650px) {
  .banner-invest {
    background-image: url('../../../assets/img/bg_banner_invest-mob.png');
    background-position: center;
    background-size: cover;
    margin-top: 30px;
    padding: 0;
    position: relative;
    background-color: #F2F2F2;
    box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.2);
    border-radius: 12px;

    .banner-inner {
      background: none;
      padding: 20px 0;
      margin: auto;
      width: 289px;
      position: unset;
      background-color: transparent;
      box-shadow: none;
      border-radius: 0;

      .title-invest {
        position: relative;
        margin-bottom: 20px;
        font-size: 24px;
        line-height: 27px;
        z-index: 1;
      }

      .colums {
        display: block;

        .text-invest {
          width: 100%;
          margin-bottom: 20px;
          font-size: 14px;
          line-height: 18px;
        }

        .btn-invest {
          margin-top: 0;
        }
      }

      .img-invest {
        background-image: url("../../../assets/img/banner_invest-mob.webp");
        width: 73px;
        height: 155px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
